import React from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import DentappNavigation from "./DentappNavigation";
import "./DentappLayout.css";
import { useSelector } from "react-redux";
import { selectUserId } from "./Login/loginSlice";

const DentappLayout = () => {
  const userId = useSelector(selectUserId);
  const location = useLocation();

  const onLoginPage = location.pathname === "/dentapp/login";
  const isAuthenticated = !!userId && Number(userId) !== 0;

  if (!isAuthenticated && !onLoginPage) {
    return <Navigate to="/dentapp/login" replace />;
  }

  return (
    <div className="dentapp-layout">
      {!onLoginPage && <DentappNavigation />}
      <main className="dentapp-main">
        <Outlet />
      </main>
    </div>
  );
};

export default DentappLayout;
